import BaseService from "./base.service";

const $groupingRules = {
  forProject(projectId) {
    return new BaseService(`/projects/${projectId}/grouping_rules`);
  },

  forAccount() {
    return new BaseService(`/grouping_rules`);
  }
};

export default $groupingRules;
